<template>
    <div>
        <vue-headful :title="'License :: MeritEHS'"/>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/settings#prequalification`">
                            Settings - Licenses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="license_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> Add</template>
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-lg-8 col-md-7">
                    <div class="card">
                        <div class="card-body">
                            <div class="row form-group">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.license_name}">License Name:</label>
                                <div class="col-md-6 col-sm-8">
                                    <input type="text" name="license_name" v-model="license.license_name" :class="{'form-control': true, 'is-invalid': errors.license_name}" placeholder="Enter License Name" />

                                    <span v-if="errors.license_name" class="text-danger">
                                        <span v-for="error in errors.license_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveLicense(this)" :disabled="saving">
                Save License
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                license_id: this.$route.params.id,
                license: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getLicense: function() {
                //Get the data
                this.$http
                    .get('subcontractors/licenses-edit' + (this.license_id ? '/' + this.license_id : ''))
                    .then(response => {
                        //Set all the data
                        this.license = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveLicense: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('subcontractors/licenses-edit' + (this.license_id ? '/' + this.license_id : ''), this.license)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('License Saved');

                    //Return to main list?
                    this.$router.push('/subcontractors/settings#licenses');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getLicense();
        }
    }
</script>
